import type {
  GetApplicantBaseDto,
  GetApplicantLogDto,
  PatchApplicantFunnelRequestDto,
} from '@/api/common/applicant/applicant.dto';
import { bearerHeader } from '@/api/common/authorization';
import { instance } from '@/api/v2/instance';
import type { Course } from '@/types';

export async function getApplicantByOnlineUserId<T extends GetApplicantBaseDto>(
  onlineUserId: string,
  courseName: Course,
  roundId?: string,
  token?: string,
) {
  const { data } = await instance.get<T>(`/v3/applicants/${onlineUserId}`, {
    params: { courseName, roundId },
    headers: bearerHeader(token),
  });

  return data;
}

export async function getOnGoingApplicantByOnlineUserId<
  T extends GetApplicantBaseDto,
>(onlineUserId: string) {
  const { data } = await instance.get<T>(
    `/v3/applicants/${onlineUserId}/ongoing`,
  );

  if (!data) {
    return null;
  }

  return data;
}

export async function patchApplicantFunnel<
  T extends PatchApplicantFunnelRequestDto,
>(body: T) {
  const { data } = await instance.patch(`/v3/applicants/me/funnel`, body, {
    headers: bearerHeader(),
  });

  return data;
}

export async function getApplicantLogsByApplicantId<
  T extends GetApplicantLogDto,
>(applicantId: string) {
  const { data } = await instance.get<T[]>(`/v3/applicantsLogs/${applicantId}`);

  if (!data) {
    return null;
  }

  return data;
}
